module.exports = __webpack_public_path__ + "static/media/timePeriod.4f361478.svg";